import {useDrawerContext} from '../context/drawer-context';

export function useForceDrawerClose() {
	const {closeDrawer} = useDrawerContext();

	return closeDrawer;
}
